<greco-tiles-table [community]="community"></greco-tiles-table>
